var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.03 -0.03 26.03 26.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99531 0.991272C10.3647 0.00574023 12.9726 -0.252319 15.4888 0.250266C18.0048 0.752837 20.3143 1.99303 22.1257 3.81204L17.8742 8.04583C16.9003 7.0678 15.6609 6.40317 14.3135 6.13404C12.9662 5.86492 11.5695 6.00293 10.2996 6.53115C9.02954 7.05943 7.94198 7.95488 7.17589 9.10621L2.18066 5.7824C3.60305 3.64475 5.62606 1.97675 7.99531 0.991272Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99531 25.0087C5.62606 24.0233 3.60305 22.3553 2.18066 20.2176L7.17589 16.8938C7.94198 18.0451 9.02954 18.9406 10.2996 19.4689C11.5695 19.9971 12.9662 20.1351 14.3135 19.866C15.6609 19.5968 16.9003 18.9322 17.8742 17.9542L22.1257 22.188C20.3143 24.007 18.0048 25.2472 15.4888 25.7497C12.9726 26.2523 10.3647 25.9943 7.99531 25.0087Z",
    fill: "#FFC93A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.0001C-4.76837e-07 10.4317 0.758381 7.91998 2.18067 5.78247L7.1759 9.10628C6.40971 10.2578 6 11.6128 6 13.0001C6 14.3873 6.40971 15.7424 7.1759 16.8939L2.18068 20.2177C0.758383 18.0802 4.76837e-07 15.5685 0 13.0001Z",
    fill: "#EB001B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 13,
    r: 3,
    fill: "#EB001B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvLogo);
export default __webpack_public_path__ + "static/media/CV-logo.cb19024b4de12727958a562cf235980f.svg";
export { ForwardRef as ReactComponent };